
import React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface PricingTestimonial {
  id: string;
  name: string;
  role: string;
  plan: string;
  content: string;
  rating: number;
}

const pricingTestimonials: PricingTestimonial[] = [
  {
    id: "1",
    name: "David Kim",
    role: "Startup Founder",
    plan: "Pro Plan",
    content: "The ROI is incredible. Product Copilot alone saves me $2000/month in consultant fees. Worth every penny.",
    rating: 5
  },
  {
    id: "2",
    name: "Lisa Thompson",
    role: "Content Manager",
    plan: "Plus Plan",
    content: "Went from 3 hours to 20 minutes for campaign briefs. The unlimited prompts feature pays for itself daily.",
    rating: 5
  },
  {
    id: "3",
    name: "Alex Rodriguez",
    role: "Product Designer",
    plan: "Pro Plan",
    content: "The advanced analytics show exactly which prompts work best. My conversion rates improved by 40%.",
    rating: 5
  }
];

const PricingTestimonials: React.FC = () => {
  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">What Our Users Say</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            See how our pricing plans deliver real value to professionals like you
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pricingTestimonials.map((testimonial) => (
            <Card key={testimonial.id} className="relative">
              <CardContent className="p-6">
                <div className="absolute top-4 right-4 text-primary/20">
                  <Quote className="h-6 w-6" />
                </div>
                
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                
                <p className="text-muted-foreground mb-4 text-sm leading-relaxed">
                  "{testimonial.content}"
                </p>
                
                <div className="flex items-center gap-3">
                  <Avatar className="w-8 h-8">
                    <AvatarFallback className="bg-primary/10 text-primary text-xs font-semibold">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="font-medium text-sm">{testimonial.name}</p>
                    <p className="text-xs text-muted-foreground">{testimonial.role}</p>
                    <p className="text-xs text-primary font-medium">{testimonial.plan}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingTestimonials;
